<template>
  <div class="availability-form-daily">
    <div class="space-y-2">
      <AvailabilityFormDailyItem
        v-for="(_, i) in recurringAvailabilities"
        :key="i"
        v-model="recurringAvailabilities[i]"
        :all-recurring-availabilities="recurringAvailabilities"
        :index="i"
        :is-first="i === 0"
        :is-last="i === recurringAvailabilities.length - 1"
        :can-add="recurringAvailabilities.length < 3"
        :disabled="disabled"
        @add-recurring-availability="
          (recurringAvailability: RecurringAvailability) =>
            $emit('addRecurringAvailability', recurringAvailability, i)
        "
        @remove-recurring-availability="
          (recurringAvailability: RecurringAvailability) =>
            $emit('removeRecurringAvailability', recurringAvailability, i)
        "
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import AvailabilityFormDailyItem from "@/components/model_edit_form/availability/AvailabilityFormDailyItem.vue"
import type { RecurringAvailability } from "@/models/recurring-availability.model.ts"

const recurringAvailabilities = defineModel<RecurringAvailability[]>({ required: true })
defineEmits(["addRecurringAvailability", "removeRecurringAvailability"])

defineProps<{
  disabled: boolean
}>()
</script>
